import React from 'react';
import { FaTimes, FaUserShield, FaPlay } from 'react-icons/fa';
import '../interview/PendingCandidatesModal.css';   // reuse existing CSS
import config from '../../../config';

const PendingSoldiersModal = ({ show, onClose, soldiers, onStartAssessment, loading }) => {
  if (!show) return null;

  return (
    <div className="pending-modal-overlay" onClick={onClose}>
      <div className="pending-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="pending-modal-header">
          <div className="pending-modal-title">
            <FaUserShield className="pending-modal-icon" />
            <h3>Pending Soldiers</h3>
          </div>
          <button className="pending-modal-close" onClick={onClose} type="button">
            <FaTimes />
          </button>
        </div>

        <div className="pending-modal-body">
          {loading ? (
            <div className="pending-loading">
              <div className="pending-spinner" />
              <p>Loading soldiers...</p>
            </div>
          ) : soldiers.length === 0 ? (
            <div className="pending-empty">
              <div className="pending-empty-icon">✅</div>
              <h4>No Pending Soldiers</h4>
              <p>All soldiers have been processed</p>
            </div>
          ) : (
            <div className="pending-candidates-list">
              {soldiers.map((soldier) => (
                <div key={soldier.soldier_id} className="pending-candidate-card">
                  <div className="pending-candidate-avatar">
                    {soldier.profile_image ? (
                      <img
                        src={`${config.baseURL}/uploads/profiles/${soldier.profile_image}`}
                        alt={`${soldier.first_name} ${soldier.last_name}`}
                      />
                    ) : (
                      <div className="pending-avatar-placeholder">
                        {(soldier.first_name?.charAt(0) || 'S').toUpperCase()}
                      </div>
                    )}
                  </div>

                  <div className="pending-candidate-info">
                    <span className="pending-candidate-name">
                      {soldier.first_name} {soldier.last_name}
                    </span>
                    <span className="pending-candidate-detail">{soldier.email}</span>
                    <span className="pending-candidate-id">Soldier ID: {soldier.soldier_id}</span>
                  </div>

                  <div className="pending-candidate-actions">
                    <button
                      className="pending-start-btn military-start-btn"
                      onClick={() => onStartAssessment(soldier)}
                      title="Start military assessment for this soldier"
                    >
                      <FaPlay />
                      <span>Start Assessment</span>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PendingSoldiersModal;